import { FIND_A_RETAIL_LOCATION } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guideData/FindRetailSpace/index";
import { GET_FUNDING_AND_LICENSES } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guideData/GetFundingAndLicenses/index";
import { LAY_THE_GROUNDWORK } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guideData/LayTheGroundwork/index";
import { ORGANIZE_STORE_OPERATIONS } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guideData/OrganizeStoreOperations/index";
import { PLAN_AND_BUY_INVENTORY } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guideData/PlanAndBuyInventory/index";
import { PROMOTE_YOUR_STORE } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guideData/PromoteYourStore/index";
import { RENOVATE_YOUR_STORE } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guideData/RenovateYourStore/index";
import { FaireAcademyGuide } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/types";

export const GUIDE_CARDS: FaireAcademyGuide[] = [
  LAY_THE_GROUNDWORK,
  GET_FUNDING_AND_LICENSES,
  FIND_A_RETAIL_LOCATION,
  RENOVATE_YOUR_STORE,
  PLAN_AND_BUY_INVENTORY,
  ORGANIZE_STORE_OPERATIONS,
  PROMOTE_YOUR_STORE,
];
